import React, { useState } from 'react';
import { ACTION_CODE, callApp } from '../../utils/callApp';
import { PAGREE_CODE } from '../../utils/codeEnum';
import './index.css';

enum AGREE_STATE {
   NORMAL = 1,//正常
   CANCEL = 2,//取消
}

const PrivacyAgreement:React.FC<{onClose:Function,data:Object}> = (props)=> {
  //展示状态
  const [agreeState, setAgreeState] = useState(AGREE_STATE.NORMAL);
  return (
    <>
      <div className="wrap_border">
        {agreeState==AGREE_STATE.NORMAL?<AgreeContent data={props.data} onClose={props.onClose} setAgreeState={setAgreeState}/>:<AgreeThink data={props.data} onClose={props.onClose} setAgreeState={setAgreeState}/>}
      </div>
    </>
  );
}
const AgreeThink:React.FC<{setAgreeState:Function,onClose:Function,data:any}> = (props)=>{

  const onCancel = ()=>{
    callApp(ACTION_CODE.POST_PAGREE,{code:PAGREE_CODE.CANCEL})
    props.onClose();
  }
  const onWait = ()=>{
    props.setAgreeState(AGREE_STATE.NORMAL)
  }
  const openUserUrl = ()=>{
    window.open(props.data?.userUrl,'_blank')
  }
  const openHideUrl = ()=>{
    window.open(props.data?.hideUrl,'_blank')
  }
  return (
    <div className="wrap33">
      <div className="title33">提示</div>
      <div className="content2">
      不授权同意{props.data?.userUrl&&<span className="blue" onClick={openUserUrl}>《用户协议》</span>}{props.data?.userUrl&&props.data?.hideUrl&&'和'}{props.data?.hideUrl&&<span className="blue"  onClick={openHideUrl}>《隐私政策》</span>}将无法进行游戏，<span className="red">是否确认退出游戏？</span>
      </div>
      <div className="bottom_wrap2">
          <div className="button_s1" onClick={onCancel}>确定</div>
          <div className="button_s2" onClick={onWait}>取消</div>
      </div>
    </div>)
}
const AgreeContent:React.FC<{setAgreeState:Function,onClose:Function,data:any}>  = (props)=>{
  const onAgree = ()=>{
    //通知取消
    callApp(ACTION_CODE.POST_PAGREE,{code:PAGREE_CODE.SUCCESS})
    props.onClose();
  }
  const onUnAgree = ()=>{
    props.setAgreeState(AGREE_STATE.CANCEL)
  }
  const openUserUrl = ()=>{
    window.open(props.data?.userUrl,'_blank')
  }
  const openHideUrl = ()=>{
    window.open(props.data?.hideUrl,'_blank')
  }
  return (
    <div className="wrap">
          <div className="titleA">个人信息保护指引</div>
          <div className="content">
              <p>在您使用游戏服务前 ，请您仔细阅读并充分了解以下条款：{props.data?.userUrl&&<span className="blue" onClick={openUserUrl}>《用户协议》</span>}{props.data?.userUrl&&props.data?.hideUrl&&'、'}{props.data?.hideUrl&&<span className="blue" onClick={openHideUrl}>《隐私政策》</span>}。</p>
              <p>阅读时，您应特别注意前述协议中免除或者限制我们责任的条款、对您权利进行限制的条款、约定争议解决方式和司法管辖的条款。</p>
              <p>如您已经仔细阅读并同意{props.data?.userUrl&&'用户协议'}{props.data?.userUrl&&props.data?.hideUrl&&'、'}{props.data?.hideUrl&&'隐私政策'}，请点击“同意”开始使用我们的服务，如果您对本协议的任何条款有异议，您可以选择“不同意并退出”并退出游戏</p>
          </div>
          <div className="bottom_wrap">
              <div className="button1" onClick={onAgree}>同意</div>
              <div className="button2" onClick={onUnAgree}>不同意并退出</div>
          </div>
      </div>)
}



export default PrivacyAgreement;
